var React = require('react');

function StarMobile (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"star"},React.createElement("path",{"id":"Icon","d":"M7.50002 1.16666L9.30252 4.81832L13.3334 5.40749L10.4167 8.24832L11.105 12.2617L7.50002 10.3658L3.89502 12.2617L4.58335 8.24832L1.66669 5.40749L5.69752 4.81832L7.50002 1.16666Z","fill":"#F2994A"})));
}

StarMobile.defaultProps = {"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none"};

module.exports = StarMobile;

StarMobile.default = StarMobile;
